jQuery( document ).ready(function($) {
    // slides
    if (!$('body').hasClass('wp-admin')) {
        var mediumBreakpoint = parseInt(getComputedStyle(document.body).getPropertyValue('--uk-breakpoint-m')) <= $(window).width();

        var entries1 = $('.ct_leistungen .template .l1 div');
        var entries2 = $('.ct_leistungen .template .l2 div');
        var line1 = $('<div class="marquee line1"></div>');
        var line2 = $('<div dir="rtl" class="marquee line2"></div>');

        if (mediumBreakpoint) {
            CreateDesktopSlider();
        }
        else {
            CreateMobileSlider();
        }

        InitializeSlider(mediumBreakpoint);

        // modal
        var modalContent = $('.ct_leistungen.default .modalTemplate');
        CheckOpenModalDialog($(".ct_leistungen.default a"), 'ct_leistungen', modalContent, true)
        CheckDeepLink($('.ct_leistungen.default'), 'ct_leistungen', modalContent, true);
    }

    function CreateMobileSlider() {
        var lineCounter = 0;
        entries1.each(function (index) {
            if (lineCounter % 2 === 0) {
                var line = line1.clone();
            } else {
                var line = line2.clone();
            }
            line.append($(this).clone());
            line.append($(this).clone());
            line.append($(this).clone());
            $('.ct_leistungen .animationContainer').append(line);
            lineCounter++;
        });

        entries2.each(function (index) {
            if (lineCounter % 2 === 0) {
                var line = line1.clone();
            } else {
                var line = line2.clone();
            }
            line.append($(this).clone());
            line.append($(this).clone());
            line.append($(this).clone());
            $('.ct_leistungen .animationContainer').append(line);
            lineCounter++;
        });
    }

    function CreateDesktopSlider() {
        entries1.each(function (index) {
            line1.append($(this).clone());
        });

        entries2.each(function (index) {
            line2.append($(this).clone());
        });

        $('.ct_leistungen .animationContainer').append(line1);
        $('.ct_leistungen .animationContainer').append(line2);
    }
    function InitializeSlider(isDesktop) {
        var autoPlay = false;
        var speed1 = 100;
        var speed2 = 100;
        var centerPadding = '20px';
        if (isDesktop) {
            autoPlay = true;
            speed1 = 7500;
            speed2 = 17000;
            centerPadding = '50px';
        }

        $('.marquee.line1').slick({
            speed: speed1,
            autoplay: autoPlay,
            autoplaySpeed: 0,
            centerMode: true,
            cssEase: 'linear',
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            infinite: true,
            initialSlide: 1,
            arrows: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            buttons: false,
            centerPadding: centerPadding
        });

        $('.marquee.line2').slick({
            speed: speed2,
            autoplay: autoPlay,
            autoplaySpeed: 0,
            centerMode: true,
            cssEase: 'linear',
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            infinite: true,
            initialSlide: 1,
            arrows: false,
            buttons: false,
            rtl: true,
            centerPadding: centerPadding
        });
    }
});